export default "__VITE_ASSET__YXEKURIW__"